import { accountAccessShowLogin } from 'actions/UiActions'
import Image from 'components/Common/Image'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import Pane from 'components/Common/Pane'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useQueryParams from 'hooks/useQueryParams'
import rem from 'polished/lib/helpers/rem'
import React from 'react'
import { connect } from 'react-redux'
import { isLoggedIn } from 'selectors/accountSelectors'
import { useAppDispatch } from 'hooks/reduxHooks'
import styled from 'styled-components'

const RootSection = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(16)};

  ${mediaQueryUp.tablet} {
    display: flex;
    align-items: center;
    padding-bottom: ${rem(20)};
    justify-content: space-between;
    gap: ${rem(60)};
  }
`

const Pictures = styled(CSSBreakpoint)`
  min-width: ${rem(312)};
  position: relative;
  min-height: ${rem(190)};
`

const ImageOne = styled(Image)`
  transform: rotate(-8.28deg) translateY(11px);
  position: absolute;
  left: 0;
  top: 0;
  width: ${rem(132)};
  height: ${rem(132)};
  & > * {
    box-shadow: ${(props) => props.theme.shadow.bottom.medium};
  }
`

const ImageTwo = styled(Image)`
  transform: rotate(7.15deg) translateX(72px);
  position: absolute;
  left: 0;
  top: 0;
  width: ${rem(160)};
  height: ${rem(160)};
  & > * {
    box-shadow: ${(props) => props.theme.shadow.bottom.medium};
  }

`

const Content = styled.div`
  color: ${props => props.theme.palette.neutral.default.one};
`

const LoginGroup = styled.div`
  margin-top: ${rem(12)};

  ${mediaQueryUp.tablet} {
    margin-top: ${rem(24)};
  }
`

const imageOne = { id: 'a8q56cuuos5oy7cgqid' }
const imageTwo = { id: '2r8kxueznadrx9g3496gp' }

interface Props {
  userName?: string;
  loggedIn: boolean;
}

function TopPicksForMeBanner(props: Props) {
  const { userName = 'you', loggedIn } = props
  const dispatch = useAppDispatch()

  const params = useQueryParams()
  const onLogin = () => dispatch(accountAccessShowLogin())
  const paramUserId = params.get('userId')

  return (
    <Pane>
      <RootSection>
        <Content>
          <Heading variant="heading1">
            {!loggedIn && 'Log in to view your top picks'}
            {loggedIn && <>Top picks for <i>{userName}</i></>}
          </Heading>
          <BodyText variant="large">Discover curated offers tailored to you</BodyText>
          {!loggedIn && <LoginGroup>
            <TextButton
              kind="primary"
              onClick={onLogin}
            >
              {paramUserId ? 'Log in' : 'Log in to view'}
            </TextButton>
          </LoginGroup>}
        </Content>
        <Pictures min="tablet">
          <ImageTwo highRes image={imageTwo} aspectRatio="1:1" />
          <ImageOne highRes image={imageOne} aspectRatio="1:1" />
        </Pictures>
      </RootSection>
    </Pane>
  )
}

function mapStateToProps(state: App.State) {
  return {
    userName: state.auth.account.givenName,
    loggedIn: isLoggedIn(state),
  }
}

export default connect(mapStateToProps)(TopPicksForMeBanner)
